import Keycloak from 'keycloak-js';

const keycloakUrl = process.env.REACT_APP_ENV === 'PRODUCTION'
  ? `https://${process.env.REACT_APP_KEYCLOAK_DOMAIN}/auth`
  : `http://${process.env.REACT_APP_KEYCLOAK_DOMAIN_LOCAL || 'localhost:8080'}`;

// If REACT_APP_KEYCLOAK_REALM is unset/empty (stale build, misconfigured ARG), avoid defaulting to focusml
// when the app is not a production build — local Keycloak is usually master only.
const keycloakRealm =
  process.env.REACT_APP_KEYCLOAK_REALM ||
  (process.env.REACT_APP_ENV === 'PRODUCTION' ? 'focusml' : 'master');

const keycloak = new Keycloak({
  url: keycloakUrl,
  realm: keycloakRealm,
  clientId: 'public',
});

export default keycloak;
